import styled from "styled-components";
import { theme } from "../../../../../constants/StyledComponents";

export const StyledArchivedFooter = styled.div`
  width: 100%;
  height: 72px;
  border-top: 1px solid ${theme.colors.purple_2};
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > div {
    margin: 0 20px 0 20px;
    display: flex;
    gap: 10px;
  }
`;
